import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9055ef5e")

_pushScopeId("data-v-9055ef5e")
const _hoisted_1 = { class: "flex flex-col gap-6 w-11/12" }
const _hoisted_2 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_3 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_4 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_5 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_6 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_7 = { class: "flex flex-row items-center relative w-full" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "\n                    bg-gray-lp-700\n                    rounded-l-md\n                    text-black-lp-300 text-center\n                    my-1.5\n                    border-gray-lp-400 border\n                    outline-none\n                    focus:shadow\n                    items-center\n                    py-1.5\n                    xxl:py-3\n                    text-12px xxl:text-14px\n                    px-2\n                  " }, " Rp ", -1)
const _hoisted_9 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-600 mt-2" }, " Aktifkan untuk menandai komoditas ini sebagai barang berbahaya. ", -1)
const _hoisted_12 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_13 = { class: "flex flex-col gap-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-600 mt-2" }, " Aktifkan untuk menambahkan biaya tambahan pada setiap dokumen yang dikirimkan dengan komoditas ini. ", -1)
const _hoisted_15 = { class: "flex flex-row gap-6 w-full" }
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-600 mt-2" }, " Aktifkan untuk menambahkan biaya tambahan pada setiap pengiriman komoditas ini. ", -1)
const _hoisted_18 = { class: "flex flex-col gap-6" }
const _hoisted_19 = { class: "flex flex-col gap-2" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-600 mt-2" }, " Klik tombol di bawah untuk mengaktifkan atau menonaktifkan status ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    title: "Ubah komoditas",
    onBack: _ctx.goBack,
    onTryAgain: _ctx.fetchDetailCommodity,
    errorCause: _ctx.errorCause,
    error: _ctx.isError,
    loading: _ctx.isLoading
  }, {
    data: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "ID komoditas",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_id,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailCommodity.commodity_id = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "Kode komoditas",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailCommodity.commodity_code = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "Nama komoditas",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_name,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailCommodity.commodity_name = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "Commodity Name",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_name_en,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailCommodity.commodity_name_en = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Nama komoditas",
            fontSize: 14,
            optional: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_name,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailCommodity.commodity_name = $event)),
                maxLength: 255,
                type: "textarea",
                showMaxLength: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "Komoditas eCargo",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_group,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.detailCommodity.commodity_group = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "flex-1 disabled",
            label: "Tipe layanan",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.commodity_service_type || '-',
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Harmonized system code",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.detailCommodity.hs_code,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.detailCommodity.hs_code = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Min. harga barang",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "\n                    py-1.5\n                    xxl:py-3\n                    px-3\n                    rounded-l-none rounded-r-md\n                    border border-gray-lp-400\n                    focus:outline-none\n                    focus:shadow\n                    my-1.5\n                    text-black-lp-300\n                    w-full\n                  ",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.minPrice = $event)),
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onInputFormatRupiah())),
                  onKeydown: _cache[10] || (_cache[10] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                }, null, 544), [
                  [_vModelText, _ctx.minPrice]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Dangerous Goods",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_Toggle, {
                  textActive: "Aktif",
                  textInactive: "Tidak aktif",
                  modelValue: _ctx.detailCommodity.isDangerousGoods,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.detailCommodity.isDangerousGoods = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Dokumen surcharge",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Toggle, {
                  textActive: "Aktif",
                  textInactive: "Tidak aktif",
                  modelValue: _ctx.isDocumentSurcharge(),
                  onClick: _ctx.onOpenDocumentSurcharge
                }, null, 8, ["modelValue", "onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_DataWrapper, {
            class: "flex-1",
            label: "Surcharge",
            fontSize: 14
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_Toggle, {
                  textActive: "Aktif",
                  textInactive: "Tidak aktif",
                  modelValue: _ctx.isSurchangeApplicable(),
                  onClick: _ctx.onOpenSurchangeApplicable
                }, null, 8, ["modelValue", "onClick"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onClose: _ctx.onCloseSurchangeApplicable,
        onSubmit: _ctx.changeSurchangeApplicable,
        title: "Konfirmasi Penonaktifan",
        message: 
          `Anda yakin ingin menonaktifkan biaya tambahan untuk komoditas “${_ctx.detailCommodity.commodity_name} - ${_ctx.detailCommodity.commodity_code}” ?`
        ,
        image: "warning",
        textSuccess: " Nonaktifkan",
        textCancel: "Kembali",
        class: "px-8"
      }, null, 8, ["onClose", "onSubmit", "message"]), [
        [_vShow, _ctx.openSurchangeApplicable]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onClose: _ctx.onCloseDocumentSurcharge,
        onSubmit: _ctx.changeDocumentSurcharge,
        title: "Konfirmasi Penonaktifan",
        message: 
          `Anda yakin ingin menonaktifkan biaya tambahan pengiriman dokumen untuk komoditas “${_ctx.detailCommodity.commodity_name} - ${_ctx.detailCommodity.commodity_code}” ?`
        ,
        image: "warning",
        textSuccess: "Nonaktifkan",
        textCancel: "Kembali",
        class: "px-8"
      }, null, 8, ["onClose", "onSubmit", "message"]), [
        [_vShow, _ctx.openDocumentSurcharge]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onClose: _ctx.onCloseStatusCommodity,
        onSubmit: _ctx.changeStatusCommodity,
        title: "Konfirmasi Penonaktifkan",
        message: "Penonaktifan status akan membuat komoditas tidak dapat digunakan dalam pengiriman.",
        image: "warning",
        textSuccess: "Nonaktifkan",
        textCancel: "Kembali",
        class: "px-8"
      }, null, 8, ["onClose", "onSubmit"]), [
        [_vShow, _ctx.openStatusCommodity]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onSubmit: _ctx.onCloseModalSuccess,
        title: "Perubahan Disimpan",
        message: `${_ctx.messageSuccess}`,
        image: "image-modal-success",
        textSuccess: "Oke",
        class: "px-8"
      }, null, 8, ["onSubmit", "message"]), [
        [_vShow, _ctx.modalSuccess]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onClose: _ctx.handlerCancelClose,
        onSubmit: _ctx.handlerClose,
        title: "Yakin Keluar Halaman ?",
        message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
        image: "are-you-sure",
        textSuccess: "Keluar",
        textCancel: "Kembali",
        class: "px-8"
      }, null, 8, ["onClose", "onSubmit"]), [
        [_vShow, _ctx.isEditTerminated]
      ]),
      _withDirectives(_createVNode(_component_Modal, {
        onSubmit: _ctx.editCommodity,
        onClose: _ctx.closeModalSave,
        title: "Konfirmasi Perubahan",
        message: 
          `Anda yakin ingin menyimpan perubahan detail komoditas “${_ctx.detailCommodity.commodity_name} - ${_ctx.detailCommodity.commodity_code}” ?`
        ,
        image: "are-you-sure",
        textSuccess: "Simpan",
        textCancel: "Kembali",
        class: "px-8"
      }, null, 8, ["onSubmit", "onClose", "message"]), [
        [_vShow, _ctx.openSave()]
      ])
    ]),
    "sub-data": _withId(() => [
      _createVNode("div", _hoisted_18, [
        _createVNode(_component_DataWrapper, {
          label: "Status Komoditas",
          fontSize: 14
        }, {
          default: _withId(() => [
            _createVNode(_component_ChipsV2, {
              class: "my-2",
              label: _ctx.detailCommodity.commodity_status
            }, null, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal dibuat",
          value: _ctx.formatDate(_ctx.detailCommodity.created_at)
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Terakhir diperbarui",
          value: _ctx.formatDate(_ctx.detailCommodity.updated_at),
          caption: _ctx.detailCommodity.updated_by
        }, null, 8, ["value", "caption"]),
        _createVNode(_component_DataWrapper, {
          class: "flex-1",
          label: "Status Komoditas",
          fontSize: 14
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode(_component_Toggle, {
                textActive: "Aktif",
                textInactive: "Tidak aktif",
                modelValue: _ctx.isStatusCommodity(),
                onClick: _ctx.onOpenStatusCommodity
              }, null, 8, ["modelValue", "onClick"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    "top-right": _withId(() => [
      _createVNode(_component_LpButton, {
        title: "Simpan",
        onClick: _ctx.openModalSave,
        "custom-class": "w-36",
        textColor: "white"
      }, null, 8, ["onClick"])
    ]),
    _: 1
  }, 8, ["onBack", "onTryAgain", "errorCause", "error", "loading"]))
})